import { Outlet } from 'react-router-dom';
import { BasePage } from '@/components/ui/base-page'

export function ServicesPage() {
  return (
    <BasePage
      title="Our Services"
      description="Comprehensive professional services for businesses and organizations"
    >
      {/* Services overview content */}

      {/* This will render child routes like ConsultingPage and ResearchPage */}
      <Outlet />
    </BasePage>
  )
}